import { type ReactNode, memo } from "react";
import { Icon, IconWeight, Popover, PopoverPlacement, PopoverTrigger } from "@clintonelec/react-storybook";
import "Components/Global/HelpPopover/HelpPopover.less";

type HelpPopoverProps = {
	children?: ReactNode;
	title: string | ReactNode;
	placement?: PopoverPlacement;
	className?: string;
};

const HelpPopover = (props: HelpPopoverProps) => {
	const { children, title, className, placement } = props;
	const compositeClass = [ "help-content", className ].join(" ");
	const helpPopoverTitle = (
		<div className="help-title">{ title }</div>
	);

	const helpPopoverContent = (
		<div className={ compositeClass }>{ children }</div>
	);

	return (
		<Popover
			title={ helpPopoverTitle }
			content={ helpPopoverContent }
			trigger={ PopoverTrigger.CLICK }
			placement={ placement || PopoverPlacement.TOP }
			className="help-popover"
			appendToBody
		>
			<Icon
				iconWeight={ IconWeight.REGULAR }
				name="question-circle"
				className="question-icon"
			/>
		</Popover>
	);
};

export default memo(HelpPopover);
